import Logger from './logger';

const HOST = 'https://account.orange.pl';

const fetchCAAP = async ({ api, body }) => {
    return await fetch(HOST + api, {
        method: 'post',
        credentials: 'include',
        headers: { 'content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify({
            client_id: 'CLOSER',
            ...body
        })
    });
};

const getAuthorizationCode = async (callback) => {
    try {
        const response = await fetchCAAP({
            api: '/cap/oauth/v2/jointSession',
            body: {
                sub_client_id: 'CLOSER',
                token_type: 'onlineCookie'
            }
        });
        const data = await response.json();
        Logger.log('JointSession ->', JSON.stringify(data));
        callback(data.authorization_code);
    } catch (error) {
        Logger.error('JointSession ->', error);
        callback(null);
    }
};

const verifyToken = async (id_token, callback) => {
    try {
        const response = await fetchCAAP({
            api: '/cap/closer/v2/verify',
            body: {
                token_type: 'onlineCookie',
                id_token: id_token
            }
        });
        const data = await response.json();
        Logger.log('VerifyToken ->', JSON.stringify(data));
        callback(data.is_connected === true ?? false);
    } catch (error) {
        Logger.error('VerifyToken ->', error);
        callback(false);
    }
};

const shortenCode = (code) => code.slice(0, 8);

const verifyCode = (code) => {
    if (!code) {
        return true;
    }

    const previousCode = window.WC?._sessionStorage?.get('ac');
    window.WC?._sessionStorage?.set('ac', shortenCode(code));

    return verifyCodeWithPrevious(code, previousCode);
};

const verifyCodeWithPrevious = (currentCode, previousCode) => {
    if (!previousCode) {
        return true;
    }

    if (shortenCode(previousCode) === shortenCode(currentCode)) {
        return false;
    }

    return true;
};

const isLoggedInECare = () => {
    return window.WC?._localStorage?.get('userStatus');
};

const isLoggedInCloser = () => {
    return window.WC?._sessionStorage?.get('isLoggedIn');
};

export {
    getAuthorizationCode,
    verifyToken,
    verifyCode,
    verifyCodeWithPrevious,
    isLoggedInECare,
    isLoggedInCloser
};
